import { Outlet, useParams } from "react-router-dom";
import { AppRouteProps } from "../../components/router/AppRoute";
import { wrapRoutes } from "../../components/router/AuthWrapper";
import CreateTab, { registerWrapperComponent } from "../../hooks/useTab";
import OperatingRoomProcedures from "./operating-room-procedures/pages/list";
import React from "react";
import { useTranslate } from "src/locales";

// Ameliyat Raporlama Component
const SurgeryReporting = React.forwardRef<HTMLDivElement, { patientId?: number | null }>((props, ref) => {
  return (
    <div ref={ref} style={{ padding: "20px", backgroundColor: "#fff5f5", minHeight: "400px" }}>
      <h2 style={{ color: "#2c3e50", borderBottom: "2px solid #e74c3c", paddingBottom: "10px" }}>
        Ameliyat Raporlama
      </h2>
      <p style={{ fontSize: "16px", color: "#34495e" }}>
        Bu bölümde ameliyat raporlama işlemleri yapılabilir.
      </p>
      <div style={{ 
        marginTop: "20px", 
        padding: "15px", 
        backgroundColor: "white", 
        borderRadius: "8px", 
        border: "1px solid #bdc3c7" 
      }}>
        <h3 style={{ color: "#e67e22" }}>Raporlama Türleri:</h3>
        <ul style={{ color: "#7f8c8d" }}>
          <li>Günlük ameliyat raporları</li>
          <li>Aylık istatistikler</li>
          <li>Doktor performans raporları</li>
          <li>Oda kullanım raporları</li>
        </ul>
      </div>
    </div>
  );
});

// Konsey İşlemleri Component
const CouncilProcedures = React.forwardRef<HTMLDivElement, { patientId?: number | null }>((props, ref) => {
  return (
    <div ref={ref} style={{ padding: "20px", backgroundColor: "#f0fff0", minHeight: "400px" }}>
      <h2 style={{ color: "#2c3e50", borderBottom: "2px solid #27ae60", paddingBottom: "10px" }}>
        Konsey İşlemleri
      </h2>
      <p style={{ fontSize: "16px", color: "#34495e" }}>
        Bu bölümde konsey işlemleri yönetilebilir.
      </p>
      <div style={{ 
        marginTop: "20px", 
        padding: "15px", 
        backgroundColor: "white", 
        borderRadius: "8px", 
        border: "1px solid #bdc3c7" 
      }}>
        <h3 style={{ color: "#8e44ad" }}>Konsey Türleri:</h3>
        <ul style={{ color: "#7f8c8d" }}>
          <li>Tıbbi konsey</li>
          <li>Etik konsey</li>
          <li>Kalite konsey</li>
          <li>Eğitim konsey</li>
        </ul>
      </div>
    </div>
  );
});

registerWrapperComponent('surgery/operating-room-procedures', () => React.createElement(OperatingRoomProcedures));
registerWrapperComponent('surgery/surgery-reporting', () => React.createElement(SurgeryReporting));
registerWrapperComponent('surgery/council-procedures', () => React.createElement(CouncilProcedures));

export const surgeryRoutes: AppRouteProps[] = [
  {
    path: "surgery",
    element: (
      <SurgeryLayout>
        <Outlet />
      </SurgeryLayout>
    ),
    children: wrapRoutes([
      { 
        path: "surgery-reporting", 
        element: <SurgeryTab title="Ameliyat Raporlama" element={SurgeryReporting} path="surgery/surgery-reporting" />,role: "frmSurgery" 
      },
      { 
        path: "council-procedures", 
        element: <SurgeryTab title="Konsey İşlemleri" element={CouncilProcedures} path="surgery/council-procedures" />,role: "frmSurgery" 
      },
      { 
        path: "operating-room-procedures", 
        element: <SurgeryTab title="Ameliyathane İşlemleri" element={OperatingRoomProcedures} path="surgery/operating-room-procedures" />,role: "actOperationProcess" 
      }
    ]),
  },
];

function SurgeryLayout(props: any) {
  return <>{props.children}</>;
}

function SurgeryTab({ title, element: Element, path }: { title: string; element: any; path: string }) {
  const { id } = useParams();
  const { t } = useTranslate();
  const patientId = id ? parseInt(id) : null;
  

  
  return <CreateTab title={t(title)} element={<Element patientId={patientId} />} patientId={patientId} path={path} />;
}


